import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Confirmation modal used by useNotification().confirm(). Mirrors UpgradeModal's
 * visual style (blurred backdrop, white rounded card, pill buttons).
 */
const ConfirmDialog = ({ message, options = {}, onConfirm, onCancel }) => {
  const { t } = useLanguage();
  const {
    title = t('confirmDialog.title', 'Confirmar acción'),
    confirmLabel = t('confirmDialog.confirm', 'Confirmar'),
    cancelLabel = t('confirmDialog.cancel', 'Cancelar'),
    danger = true,
  } = options;
  const accent = danger ? '#ff375f' : '#0071e3';

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center px-4"
      style={{ background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(6px)' }}
      onClick={onCancel}
    >
      <div
        className="bg-white max-w-sm w-full overflow-hidden"
        style={{ borderRadius: 20, boxShadow: '0 24px 60px rgba(0,0,0,0.18)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 pt-6 pb-5">
          <h2 className="text-lg font-semibold" style={{ color: '#1d1d1f', letterSpacing: '-0.02em', margin: 0 }}>
            {title}
          </h2>
          <p className="text-sm mt-2 leading-relaxed" style={{ color: '#6e6e73' }}>
            {message}
          </p>
        </div>
        <div className="px-6 pb-6 flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 rounded-full font-medium transition hover:bg-black/5"
            style={{ color: '#6e6e73', border: '1px solid rgba(0,0,0,0.1)', background: 'none', cursor: 'pointer' }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-3 rounded-full font-medium text-white transition-all hover:opacity-90"
            style={{ background: accent, border: 'none', cursor: 'pointer' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
